import http from 'services/http';

export interface VocabDefinition {
  partOfSpeech: string;
  meaning: string;
  uz: string;
  ru: string;
  example: string;
}

export interface VocabWord {
  id: string;
  word: string;
  context: string;
  createdAt?: string;
  /** Sent only when the learner's plan includes vocabulary. */
  definition?: VocabDefinition;
}

export interface VocabList {
  /** The plan includes definitions and the download. */
  access: boolean;
  words: VocabWord[];
}

export async function listVocabWords(): Promise<VocabList> {
  const { data } = await http.request.get<{ data: VocabList }>('/api/vocabulary/words');
  return data.data;
}

export async function saveVocabWord(word: string, context: string): Promise<VocabWord> {
  const { data } = await http.request.post<{ data: VocabWord }>('/api/vocabulary/words', { word, context });
  return data.data;
}

export async function deleteVocabWord(id: string): Promise<void> {
  await http.request.delete(`/api/vocabulary/words/${encodeURIComponent(id)}`);
}

/** Writes definitions for up to 20 words without one. 403 `PORTAL_PLAN_REQUIRED` without a plan. */
export async function defineVocabWords(): Promise<{ defined: number; remaining: number }> {
  const { data } = await http.request.post<{ data: { defined: number; remaining: number } }>('/api/vocabulary/words/define');
  return data.data;
}

/** The list as a CSV file. 403 `PORTAL_PLAN_REQUIRED` without a plan. */
export async function downloadVocabCsv(): Promise<Blob> {
  const { data } = await http.request.get<Blob>('/api/vocabulary/export', { responseType: 'blob' });
  return data;
}

/** The API's refusal code, if any. */
export function vocabErrorCode(error: unknown): string | undefined {
  const code = (error as { response?: { data?: { code?: unknown } } } | null)?.response?.data?.code;
  return typeof code === 'string' ? code : undefined;
}
